import { Col, Row } from 'antd'
import React from 'react'
import styled from 'styled-components'

import EmailSvg from 'assets/images/Email.svg'
import EmailGoogle from 'assets/images/email_gmail.png'
import EmailOutlook from 'assets/images/email_outlook.png'

type FormSentProps = {
  email: string
  linkNoun?: string
}

const FormSent: React.FC<FormSentProps> = ({
  email,
  linkNoun = 'a reset link',
}) => {
  return (
    <Wrapper justify="center">
      <Col>
        <Row justify="center">
          <EmailImg src={EmailSvg} />
        </Row>
        <Row justify="center">
          <Text>
            We’ve sent {linkNoun} to{' '}
            <b>{email.length > 0 ? email : 'your email'}</b>
            <br />
            It should arrive within 2 minutes.
          </Text>
        </Row>
        <Links>
          <EmailLink href="https://mail.google.com" target="_blank">
            <ImgBox>
              <EmailImgGoogle src={EmailGoogle} />
            </ImgBox>
            <LinkText>Open Gmail</LinkText>
          </EmailLink>
          <EmailLink href="https://outlook.live.com" target="_blank">
            <ImgBox>
              <EmailImgOutlook src={EmailOutlook} />
            </ImgBox>
            <LinkText>Open Outlook</LinkText>
          </EmailLink>
        </Links>
      </Col>
    </Wrapper>
  )
}

const Wrapper = styled(Row)`
  color: var(--color-auth-grey);
  font-size: 16px;
  padding: 20px;
`

const EmailImg = styled.img`
  width: 64px;
  height: 44px;
  margin-bottom: 20px;
`

const Text = styled(Col)`
  max-width: 412px;
  width: 100%;
  margin-bottom: 24px;

  text-align: center;

  @media only screen and (max-width: 768px) {
    max-width: 256px;
  }
`

const Links = styled(Row)`
  justify-content: center;
  flex-flow: row nowrap;

  a:first-child {
    margin-right: 21px;
  }
`

const EmailLink = styled.a`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  width: 148px;
  min-height: 99px;

  border: 0.5px solid #acb5bd;
  border-radius: 5px;

  color: var(--color-auth-grey);
  text-align: center;
  text-decoration: none !important;
  transition: background 0.2s ease;

  &:hover,
  &:visited,
  &:active,
  &:focus {
    text-decoration: none !important;
  }

  &:hover {
    background: #5072a426;
    color: var(--color-auth-grey);
  }
`

const ImgBox = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  min-height: 40px;
`

const EmailImgGoogle = styled.img`
  width: 40px;
  height: 32px;
`

const EmailImgOutlook = styled.img`
  width: 40px;
  height: 40px;
`

const LinkText = styled.div`
  margin-top: 16px;
`

export { FormSent }
